import { render } from "./Accounts.vue?vue&type=template&id=f9bf72be&ts=true"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__